import React from "react";
import "./styles/projects.css";
import ProjectList from "./ProjectList";

function Projects() {
  return (
    <div className="projectDisplay">
      <h1>My Portfolio</h1>
      <ProjectList />
    </div>
  );
}

export default Projects;
